

const Style = ({ height }) => {

    const mainEl = '.layout';

    return <style dangerouslySetInnerHTML={{
        __html: `
	 
        ${mainEl}{
			height: ${height}px;
		} 

	 

	`.replace(/\s+/g, ' ')
    }} />
}
export default Style;